import { render } from "./ActivateTrackpoint.vue?vue&type=template&id=0c6409f4&scoped=true"
import script from "./ActivateTrackpoint.vue?vue&type=script&lang=ts"
export * from "./ActivateTrackpoint.vue?vue&type=script&lang=ts"

import "./ActivateTrackpoint.vue?vue&type=style&index=0&id=0c6409f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c6409f4"

export default script